import { Col, Row } from '@qonsoll/react-design'
import {
  HeaderBreadcrumbs,
  PageActions,
  PageWrapperActionsUnderTitle,
  Spinner
} from 'components'
import {
  RejectReasonFilter,
  RejectReasonTable
} from 'domains/RejectReason/components'
import { useFilter, useGetCustomDataSource } from 'hooks'
import {
  useGetRejectReasons,
  useRejectReasonBaseActions
} from 'domains/RejectReason/hooks'
import { useMemo, useState } from 'react'

import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'

const RejectReasonAll = (props) => {
  const { withHeader = true } = props

  const [collection, setCollection] = useState()
  /* Getting translations instance */
  const { t } = useTranslations()

  /* Getting filter params */
  const filterParams = useFilter('rejectReason')

  /* Destructuring filter params */
  const { filterVisibility, filterData, setFilterVisibility } = filterParams

  /* Building filter query */
  const ref = useMemo(() => filterData, [filterData])

  /* Fetching newspapers */
  const [rejectReasons, loading] = useGetRejectReasons(ref)

  const [customDataSource, customDataSourceLoading] =
    useGetCustomDataSource(rejectReasons)

  /* Getting base actions */
  const { onBack, onCreate } = useRejectReasonBaseActions()

  /* Configuring page header */
  const headingProps = {
    title: t('Reject reasons'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  /* Configuring page actions */
  const actions = {
    filter: true,
    search: true,
    create: true
  }

  return (
    <PageWrapperActionsUnderTitle
      action={
        withHeader ? (
          <PageActions
            {...filterParams}
            onCreate={onCreate}
            circle
            actions={actions}
            filterVisibility={filterVisibility}
            setFilterVisibility={setFilterVisibility}
            collection={customDataSource}
            filterMenu={<RejectReasonFilter {...filterParams} />}
            setCollection={setCollection}
            searchPlaceholder="Search by Reason Title"
            searchField="title"
          />
        ) : null
      }
      onBack={withHeader ? onBack : null}
      breadcrumbs={withHeader ? <HeaderBreadcrumbs /> : null}
      headingProps={withHeader ? headingProps : null}>
      <Row noGutters>
        {loading || customDataSourceLoading ? (
          <Col>
            <Spinner height="60vh" text={t('Reject reasons loading')} />
          </Col>
        ) : (
          <Col cw={12}>
            <RejectReasonTable dataSource={collection ?? customDataSource} />
          </Col>
        )}
      </Row>
    </PageWrapperActionsUnderTitle>
  )
}

RejectReasonAll.propTypes = {
  isListWithCreate: PropTypes.bool,
  withHeader: PropTypes.bool
}

export default RejectReasonAll
